import { ApolloLink } from 'apollo-link';

export const SSR_TEST_QUERY_FIRED: Record<string, number> = {};

export const SSRTestLink = () =>
	new ApolloLink((operation, forward) => {
		if (SSR_TEST_QUERY_FIRED[operation.operationName]) {
			SSR_TEST_QUERY_FIRED[operation.operationName]++;
		} else {
			SSR_TEST_QUERY_FIRED[operation.operationName] = 1;
		}
		return forward(operation);
	});
